(function(){
    class GroupRule extends SlotsEngine.instantiators.SymbolRule{
        constructor(){
            super();
        }

        initialise(json){
            let groupings = {};
            for (let i = 0; i < json.rules.length; ++i){
                groupings = Object.assign(groupings,json.rules[i]);
            }
            super.initialise(groupings);
        }

        isSymbolValid(symbolId, previousWindowSymbols, nextSymbol){ //REVERSE(maybe)
            if (symbolId === previousWindowSymbols[previousWindowSymbols.length - 1]) // cant continue the group from previous group
                return false;
            else if (symbolId === nextSymbol)
                return false;
            else if (!this.doesSymbolHaveRule(symbolId))  // if there is no rule then it is fine
                return true;

            return true;
        }

        testReelBandPassesRule(reelBand){
            for (let prop in this._rules){
                if (this._rules.hasOwnProperty(prop)){
                    let symId = Number(prop);
                    let count = this._rules[prop].count;
                    for (let i = 0; i < reelBand.length; ++i){                        
                        if (reelBand[i] === symId){
                            let brokenRule = false;
                            let matching = 1;
                            for (let j = 1; j < count; ++j){
                                if (reelBand[(i + j) % reelBand.length] !== symId){
                                    brokenRule = true;
                                    break;
                                }
                                ++matching;
                            }
                            if (reelBand[(i+count) % reelBand.length] === symId)
                                brokenRule = true;

                            if (brokenRule){
                                if (i === 0){ // lets not stop just yet, it might wrap around completing the rule
                                    let symbolsMissing = count - matching;
                                    reelBand = reelBand.slice( reelBand.length -symbolsMissing, reelBand.length ).concat(reelBand);
                                    reelBand.splice(reelBand.length -symbolsMissing, symbolsMissing);
                                    i = -1;
                                }
                                else{
                                    return false;
                                }
                            }
                            else{
                                i += count-1;
                            }
                        }
                    }
                }
            }
            return true;
        }

        getNumSymbolsToReserve(symbolId){            
            if (!this.doesSymbolHaveRule(symbolId))
                return 0;

            return this._rules[""+symbolId].count;          
        }

        getReservedSymbols(symbol, num){
            return Array(num).fill(symbol); 
        }

        getAdditionalSymbolsNeededToSatisfyRule(symbolsInView){ //REVERSE (maybe)
            let res = [];
            let lastSymbol = symbolsInView[symbolsInView.length - 1];
            if (this.doesSymbolHaveRule(lastSymbol)){
                let count = 1;
                for (let i = symbolsInView.length - 2; i >=0; --i){
                    if (symbolsInView[i] == lastSymbol){
                        ++count;
                    }
                    else{
                        break;
                    }
                }

                let numExtraNeeded = Math.max(this.getNumSymbolsNeeded(lastSymbol) - count,0);
                res = Array(numExtraNeeded).fill(lastSymbol);
            }

            return res;
        }
    }
    resourceManager.registerController("SymbolRules_group", function(){        
        return new GroupRule();
    });
})();